import { Button, Form, Modal } from 'antd';
import React from 'react';
import ManualChargeForm from 'src/components/Reporting/ManualChargeForm';
import { charge } from "../../apis/Reporting/ManualCharge";

interface ILocalProps {
    currencySymbol: string;
    customerID: number;
    customerName: string;
    creditBalance: string;
    gracePeriodActive: boolean;
    handleClose: () => void;
    handleSubmit: () => void;
}

interface ILocalState {
    loading: boolean;
    responseMessage: string;
}

class ManualChargeModal extends React.Component<ILocalProps, ILocalState> {
    public state = { loading: false, responseMessage: '' };

    public formReference: Form | null = null;

    public handleClose = () => {
        this.props.handleClose();
    };

    public handleSubmit = () => {
        const { customerID } = this.props;
        if (this.formReference !== null && this.formReference.props.form) {
            this.formReference.props.form.validateFields({ force: true }, async (err, values) => {
                if (err) {
                    const message = err.toString() === '[object Object]' ? '' : err.toString();
                    this.setState({ responseMessage: message, loading: false });
                    return;
                }
                this.setState({ loading: true });
                const response = await charge(customerID, values.chargeAmount, values.creditDeduction, values.note);
                this.setState({ responseMessage: response.message, loading: false });
                if (response.success) {
                    this.props.handleSubmit();
                }
            });
        }
    };

    public saveFormRef = (formReference: Form) => {
        this.formReference = formReference;
    };

    public render() {
        const title = 'Manual Charge for ' + this.props.customerName;
        return (
            <Modal
                closable={false}
                title={title}
                visible={true}
                className="modal"
                footer={[
                    <Button key="close" onClick={this.handleClose} style={{ float: 'left' }}>Close</Button>,
                    <Button key="submit" loading={this.state.loading} onClick={this.handleSubmit} type="primary">Submit</Button>,
                ]}
            >
                {!this.props.gracePeriodActive &&
                    <ManualChargeForm
                        creditBalance={this.props.creditBalance}
                        currencySymbol={this.props.currencySymbol}
                        wrappedComponentRef={this.saveFormRef}
                    />
                }
                <span className="errorMessage">{this.props.gracePeriodActive ? "Customer is currently in a grace period. Manual charges have been disabled." : this.state.responseMessage}</span>
            </Modal>
        );
    }
}

export default ManualChargeModal;
